import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card hotelCard hotelCard--modal hoverShadow"
}
const _hoisted_2 = { class: "hotelCard__head" }
const _hoisted_3 = { class: "hotelCard__head__service" }
const _hoisted_4 = { class: "hotelCard__main hotelCard__main--modal" }
const _hoisted_5 = { class: "dataInfo" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "dataInfo__type" }, "Заезд", -1)
const _hoisted_7 = { class: "dataInfo__data" }
const _hoisted_8 = { class: "dataInfo__data__data" }
const _hoisted_9 = { class: "dayName" }
const _hoisted_10 = { class: "dataInfo__data__time" }
const _hoisted_11 = { class: "dataInfo" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "dataInfo__type" }, "Выезд", -1)
const _hoisted_13 = { class: "dataInfo__data" }
const _hoisted_14 = { class: "dataInfo__data__data" }
const _hoisted_15 = { class: "dayName" }
const _hoisted_16 = { class: "dataInfo__data__time" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"services\"><div class=\"services__title\">Услуги номера</div><ul class=\"services__list\"><li class=\"iconCond\"></li><li class=\"iconNews\"></li><li class=\"clean\"></li><li class=\"wifi\"></li><li class=\"food\"></li><li class=\"bed\"></li></ul></div>", 1)
const _hoisted_18 = { class: "more-info" }
const _hoisted_19 = {
  key: 0,
  class: "more-info__annual"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("h3", { class: "more-info__title" }, "Аннуляционная политика", -1)
const _hoisted_21 = { class: "more-info__text" }
const _hoisted_22 = { class: "more-info__text" }
const _hoisted_23 = {
  key: 1,
  class: "more-info__room-info"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("h3", { class: "more-info__title" }, "Информация о номере", -1)
const _hoisted_25 = { class: "more-info__text" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "separateBlock sepLine" }, [
  /*#__PURE__*/_createVNode("div", { class: "separateBlock__left ovalLeft" }),
  /*#__PURE__*/_createVNode("div", { class: "separateBlock__rigth ovalRight" })
], -1)
const _hoisted_27 = { class: "hotelCard__footer" }
const _hoisted_28 = { class: "infoPrice" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Итого: ")
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, "*Без НДС", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("button", { class: "hotelsCard-modal__btn-dropdown hotelsCard-modal__btn-dropdown--info" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_ctx.room)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.room.baseHotelRateAccessor.systemName), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.room.roomName.bs.rus), 1 /* TEXT */)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", null, _toDisplayString(_ctx.parseDate(_ctx.room.baseHotelRateAccessor.accessor.checkin, "DD MMM")), 1),
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.parseDate(_ctx.room.baseHotelRateAccessor.accessor.checkin, "dddd")), 1)
              ]),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.room.defaultCheckInTime), 1)
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", null, _toDisplayString(_ctx.parseDate(
                  _ctx.room.baseHotelRateAccessor.accessor.checkout,
                  "DD MMM"
                )), 1),
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.parseDate(_ctx.room.baseHotelRateAccessor.accessor.checkout, "dddd")), 1)
              ]),
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.room.defaultCheckOutTime), 1)
            ])
          ]),
          _hoisted_17,
          _createVNode(_component_Accordion, {
            activeIndex: _ctx.active,
            class: "more-info-accordion"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AccordionTab, null, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_18, [
                    (_ctx.room.cancelationPolicies)
                      ? (_openBlock(), _createBlock("section", _hoisted_19, [
                          _hoisted_20,
                          _createVNode("p", _hoisted_21, " Стоимость отмены и/или изменения бронирования до " + _toDisplayString(_ctx.room.cancelationPolicies[0].dateEndStr) + " по московскому времени: " + _toDisplayString(_ctx.room.cancelationPolicies[0].refundFee.value) + " " + _toDisplayString(_ctx.room.cancelationPolicies[0].currencyCode), 1),
                          _createVNode("p", _hoisted_22, " Отмена и/или изменение бронирование, произведенные после " + _toDisplayString(_ctx.room.cancelationPolicies[1].dateStartStr) + " по московскому времени повлекут штраф " + _toDisplayString(_ctx.room.cancelationPolicies[1].refundFee.value
                    ? _ctx.room.cancelationPolicies[1].refundFee.value
                    : _ctx.room.cancelationPolicies[1].refundFee.baseRefundFee) + " " + _toDisplayString(_ctx.room.cancelationPolicies[1].currencyCode), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.room.roomDescription.bs)
                      ? (_openBlock(), _createBlock("section", _hoisted_23, [
                          _hoisted_24,
                          _createVNode("p", _hoisted_25, _toDisplayString(_ctx.room.roomDescription.bs.rus), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeIndex"])
        ]),
        _hoisted_26,
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode("b", null, _toDisplayString(_ctx.room.extendedRatePrice.comparisionTotalPrice) + "₽ ", 1),
            _hoisted_30
          ]),
          _hoisted_31,
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.open(...args))),
            class: ["hotelsCard-modal__btn-dropdown", { open: _ctx.active === 0 }]
          }, null, 2),
          (!_ctx.isSelected)
            ? (_openBlock(), _createBlock("a", {
                key: 0,
                href: "#",
                class: "infoBtn",
                onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.select(_ctx.room)), ["prevent"]))
              }, "Выбрать"))
            : _createCommentVNode("", true),
          (_ctx.isSelected)
            ? (_openBlock(), _createBlock("a", {
                key: 1,
                href: "#",
                class: "infoBtn",
                onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.unselect()), ["prevent"]))
              }, "Удалить"))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}